export class EnemyInfoDto {
  static fromApi(data) {
    return {
      canHappen: data.canHappen,
      listSyptoms: data.listSyptoms,
      outbreakConditions: data.outbreakConditions,
    };
  }
}

export class EnemiesInfoDto {
  static fromApi(dataArray, enemies) {
    const info = {};

    if (!enemies?.length) {
      return info;
    }

    enemies.forEach((enemy, index) => {
      const data = dataArray[index];
      info[enemy.uuid] = data;
    });

    return info;
  }
}

export class EnemyOperationsDto {
  static fromApi(data, enemyId, drugTaskId, activeSubstances) {
    const { errors, treatments } = mapDrugActionWithPesticides(
      enemyId,
      drugTaskId,
      data.treatments,
      data.pesticides,
      activeSubstances
    );
    const preventions = populatePreventiveActions(data);

    return {
      preventions,
      treatments,
      errors,
    };
  }
}

export class EnemiesOperationsDto {
  static fromApi(dataArray, enemies, drugTaskId, activeSubstances) {
    const actions = {};

    if (!enemies?.length) {
      return actions;
    }

    enemies.forEach((enemy, index) => {
      const data = dataArray[index];
      // actions[enemy.uuid] = EnemyOperationsDto.fromApi(
      //   data,
      //   enemy.uuid,
      //   drugTaskId,
      //   activeSubstances
      // );
      actions[enemy.uuid] = data;
    });

    return actions;
  }
}

/**
 * ------- HELPER FUNCTIONS FOR ENEMY OPERATIONS -------
 */

const findBioVersionsOfPesticide = (enemyId, pesticide, activeSubstances) => {
  const substances = activeSubstances?.[pesticide?.uuid];

  const pesticideVersions = {
    bio: undefined,
    nonBio: undefined,
  };

  const result = {
    error: "",
    bioVersions: [],
  };

  if (!substances) {
    if (process.env.REACT_APP_ENV_QA) {
      // console.warn(
      //   `No active substances found for pesticide: ${pesticide?.name?.nameEn}. Active Substances are fetch from the /agro/crop-agrochemichals endpoint.`
      // );
      result.error = pesticide?.name?.nameEn + " - " + pesticide?.uuid;
    }
  } else {
    for (let i = 0; i < substances.length; i++) {
      const causeId = substances[i].causeId;
      if (!causeId.includes(enemyId)) {
        continue;
      }
      const agrochemical = substances[i].agrochemicalRead;
      if (!pesticideVersions.bio && agrochemical.bio) {
        pesticideVersions.bio = { ...pesticide, bio: true };
        continue;
      }
      if (!agrochemical.bio) {
        pesticideVersions.nonBio = { ...pesticide, bio: false };
      }
    }

    result.bioVersions = Object.values(pesticideVersions).filter((pesticide) =>
      Boolean(pesticide)
    );
  }
  return result;
};

// If action is drugAction, add the pesticides
const mapDrugActionWithPesticides = (
  enemyId,
  actionId,
  treatments = [],
  pesticides = [],
  activeSubstances
) => {
  const populatedTreatments = [];
  const errors = [];
  treatments.forEach((treatment) => {
    const uuid = treatment?.operation?.task?.uuid;

    if (actionId === uuid) {
      pesticides.forEach((pesticide) => {
        const { error, bioVersions: pesticidesWithBioVersions } =
          findBioVersionsOfPesticide(enemyId, pesticide, activeSubstances);

        if (error) {
          errors.push(error);
        }
        pesticidesWithBioVersions.forEach((pesticide) =>
          populatedTreatments.push({
            ...treatment,
            operation: { ...treatment.operation, pesticide },
          })
        );
      });
    } else {
      populatedTreatments.push(treatment);
    }
  });

  return { treatments: populatedTreatments, errors };
};

const populatePreventiveActions = ({ preventions = [], diagnoses = [] }) => {
  const preventionActions = [...diagnoses];
  preventions.forEach((prevention) => {
    const taskId = prevention.operation?.task?.uuid;
    const operationId = prevention.operation?.operationType?.uuid;

    const alreadyExists = preventionActions.some(
      (action) =>
        action.operation?.task?.uuid === taskId &&
        action.operation?.operationType?.uuid === operationId
    );

    if (!alreadyExists) {
      preventionActions.push(prevention);
    }
  });
  return preventionActions;
};
